import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore, Role } from '@/store/auth';

export function ProtectedRoute({ children, role }: { children: JSX.Element; role?: Role }) {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (role && user.role !== role) return <Navigate to="/dashboard" replace />;
  return children;
}
